var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "lastBottom end",
        attrs: { id: "objectiveBottomSecondary" }
      },
      [
        _c("div", { staticClass: "cols" }, [
          _c("div", { staticClass: "centered" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "osReverse", class: { reverse: _vm.isAndroid } },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.global.apple_link,
                      title: _vm.global.download_apple,
                      target: "_blank",
                      rel: "noopener"
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "download_button",
                      attrs: {
                        src: require("@/assets/images/SVG/ios_download.svg"),
                        height: "38",
                        alt: _vm.global.download_google
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.global.google_link,
                      title: _vm.global.download_google,
                      target: "_blank",
                      rel: "noopener"
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "download_button",
                      attrs: {
                        src: require("@/assets/images/SVG/google_play_FR.svg"),
                        height: "38",
                        alt: _vm.global.download_google
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "lastBottom", attrs: { id: "objectiveBottom" } }, [
      _c("div", { staticClass: "cols" }, [
        _c("div", { staticClass: "centered" }, [
          _c("h4", [
            _vm._v(
              "\n          Pour vendre vos articles en magasin, téléchargez l’application\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "osReverse", class: { reverse: _vm.isAndroid } },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.global.apple_link,
                    target: "_blank",
                    title: _vm.global.download_apple,
                    rel: "noopener"
                  }
                },
                [
                  _c("img", {
                    staticClass: "download_button",
                    attrs: {
                      src: require("@/assets/images/SVG/ios_download.svg"),
                      height: "38",
                      alt: _vm.global.download_apple
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.global.google_link,
                    title: _vm.global.download_google,
                    target: "_blank",
                    rel: "noopener"
                  }
                },
                [
                  _c("img", {
                    staticClass: "download_button",
                    attrs: {
                      src: require("@/assets/images/SVG/google_play_FR.svg"),
                      height: "38",
                      alt: _vm.global.download_google
                    }
                  })
                ]
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("footer", [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "cols cont" }, [
        _c("div", { staticClass: "col" }, [
          _c("h4", [_vm._v("Liens pratiques")]),
          _vm._v(" "),
          _c("ul", [
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: "/FAQ",
                      target: "_self",
                      name: "réponses aux questions à propos de idtroc",
                      rel: "tag"
                    }
                  },
                  [
                    _vm._v(
                      "\n              Foire aux questions IDTROC\n            "
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: "/CGU",
                      target: "_self",
                      name:
                        "conditions générales d'utilisation de l'application idtroc",
                      rel: "tag"
                    }
                  },
                  [
                    _vm._v(
                      "\n              Conditions générales d'utilisation\n            "
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: "/mentions-legales",
                      target: "_self",
                      name: "mentions légales de l'application idtroc",
                      rel: "tag"
                    }
                  },
                  [_vm._v("\n              Mentions Légales\n            ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: "/politique-confidentialite",
                      target: "_self",
                      name:
                        "politique de confidentialité de l'application idtroc",
                      rel: "tag"
                    }
                  },
                  [
                    _vm._v(
                      "\n              Politique de Confidentialité\n            "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(4)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _vm._v("\n          Pour vendre vos articles en magasin,\n          "),
      _c("br"),
      _vm._v("téléchargez l'application\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "centered" }, [
      _c("img", {
        staticStyle: {
          "min-width": "280px",
          "max-width": "550px",
          width: "100%"
        },
        attrs: {
          src: require("@/assets/images/SVG/idkids_brands.svg"),
          width: "320",
          alt: "idkids we act for kids marques idtroc"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.okaidi.fr/programme-fidelite-2",
            target: "_blank",
            rel: "noopener"
          }
        },
        [
          _vm._v("\n              Programme de\n              "),
          _c("b", [_vm._v("fidélité Okaïdi-obaïbi")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.oxybul.com/programme-fidelite",
            target: "_blank",
            rel: "noopener"
          }
        },
        [
          _vm._v("\n              Programme de\n              "),
          _c("strong", [_vm._v("fidélité Oxybul")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("h4", [_vm._v("Communauté & Marques")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://www.idkids.fr/idtroc-vetements-et-jouets-d-occasion-okaidi-obaibi-oxybul",
                title: "IDTROC sur idkids",
                target: "_blank",
                rel: "noopener"
              }
            },
            [_vm._v("\n              ÏDKIDS\n            ")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.okaidi.fr/idtroc-4",
                title: "idtroc sur okaidi obaibi",
                target: "_blank",
                rel: "noopener"
              }
            },
            [_vm._v("\n              Okaïdi - Obaïbi\n            ")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.oxybul.com/id-troc",
                title: "idtroc sur oxybul",
                target: "_blank",
                rel: "noopener"
              }
            },
            [_vm._v("\n              Oxybul\n            ")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.catimini.com/fr-fr/website/465-idtroc",
                title: "catimini sur oxybul",
                target: "_blank",
                rel: "noopener"
              }
            },
            [_vm._v("\n              Catimini\n            ")]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ab164b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 